<template>
  <Section>
    <template #header>
      <div class="mr-auto">
        <strong style="color:black">Contact</strong>
      </div>
      <ContactDialog v-if="request.is_valid" :customer_request="request" />
    </template>
    
    <Item icon="mdi-account">{{ request.name }}</Item>
    <Item icon="mdi-phone">{{ request.phone }}</Item>
    <Item icon="mdi-home">{{ request.zipcode }}</Item>
  </Section>
</template>

<script>
  import { Section, Item } from '@/components/pages'
  import ContactDialog from '../dialogs/Contact.vue'

  export default {
    name: 'ContactsSection',

    components: { ContactDialog, Item, Section },

    props: {
      request: { type: Object, required: true, },
    },
  }
</script>